import * as React from "react";

import V1AssetsLibrary from "@v1/components/assets/AssetsLibrary";

const AssetsLibraryPane: React.FC = () => {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <V1AssetsLibrary />
    </div>
  );
};

export default AssetsLibraryPane;
